module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/hero-desktop-c2337d5cb26f82c97fd8bfd63042d7b0.png";